import request from '@/utils/request'

/**
 * 获取素材库列表
 * @returns
 */
export function getMaterialLibraryList(params = {}) {
  return request({
    url: '/sourceMaterial/list',
    method: 'get',
    params
  })
}
// 设置外部群的机器人回调地址
export function feishuChatSetWebhook(data = {}) {
  return request({
    url: '/feishu/chat/setWebhook',
    method: 'post',
    data
  })
}
// 通知类型下拉列表
export function feishuChatGetErrorTypeList(params) {
  return request({
    url: '/feishu/chat/getErrorTypeList',
    method: 'get',
    params
  })
}
// 添加错误群类型
export function feishuChatAddType(data) {
  return request({
    url: '/feishu/chat/addType',
    method: 'post',
    data
  })
}

/**
 * 新增素材
 * @param {Object} data 数据对象
 * @returns
 */
export function newMaterial(data = {}) {
  return request({
    url: '/sourceMaterial/store',
    method: 'post',
    data
  })
}
/**
 * 批量新增素材
 * @param {Object} data 数据对象
 * @returns
 */
export function newMateriallist(data = {}) {
  return request({
    url: '/sourceMaterial/storeBatch',
    method: 'post',
    data
  })
}

/**
 * 菜单回复富文本创建
 * @param {Object} data 数据对象
 * @returns
 */
export function addRichtext(data = {}) {
  return request({
    url: '/menuRichText/create',
    method: 'post',
    data
  })
}
/**
菜单富文本搜索展示
 * @returns
 */
export function menuRichText(data) {
  return request({
    url: '/menuRichText/list',
    method: 'get',
    data
  })
}
/**
添加公共菜单
 * @returns
 */
export function menuTemplate(data) {
  return request({
    url: '/menuTemplate/store',
    method: 'post',
    data
  })
}
// 菜单富文本列表
export function menuRichTextlist(params) {
  return request({
    url: '/menuRichText/index',
    method: 'get',
    params
  })
}
// 公众号列表
export function officialAccountlist(params) {
  return request({
    url: '/officialAccount/index',
    method: 'get',
    params
  })
}
// 公众号详情
export function officialAccountlistinfo(params) {
  return request({
    url: '/officialAccount/detail',
    method: 'get',
    params
  })
}
// 公众号搜索展示
export function officialSearchlist(params) {
  return request({
    url: '/officialAccount/list',
    method: 'get',
    params
  })
}
// 菜单模板列表
export function menutemplatelist(params) {
  return request({
    url: '/menuTemplate/index',
    method: 'get',
    params
  })
}
// 公众号菜单绑定
export function officialaccountbind(data) {
  return request({
    url: '/officialAccountMenu/bind',
    method: 'post',
    data
  })
}
// 菜单模板详情
export function menudetial(params) {
  return request({
    url: '/menuTemplate/detail',
    method: 'get',
    params
  })
}
// 客服消息标识
export function customerlogo(params) {
  return request({
    url: '/customerMessage/signList',
    method: 'get',
    params
  })
}
// 客服消息类型列表
export function customermessagelist(data) {
  return request({
    url: '/customerMessage/msgTypeList',
    method: 'get',
    data
  })
}
// 客服消息创建
export function customerservicecreat(data) {
  return request({
    url: '/customerMessage/store',
    method: 'post',
    data
  })
}
// 客服消息列表
export function customercreatlist(params) {
  return request({
    url: '/customerMessage/index',
    method: 'get',
    params
  })
}
// 策略类型
export function strategyList(params) {
  return request({
    url: '/strategy/typeList',
    method: 'get',
    params
  })
}
// 预览模式群发
export function getstrategyPreview(params) {
  return request({
    url: '/strategyPreview/index',
    method: 'get',
    params
  })
}
// 新增预览群发
export function createStrategyPreview(params) {
  return request({
    url: '/strategyPreview/create',
    method: 'post',
    params
  })
}
// 延时触发动作类型
export function actionHelper(params) {
  return request({
    url: '/strategyDelay/delayTypeList',
    method: 'get',
    params
  })
}
// 获取策略平台
export function strategyPlatform(params) {
  return request({
    url: '/bookPlatform/list',
    method: 'get',
    params
  })
}
// 获取策略平台(活动链接专用)
export function strategyPlatformtwo(params) {
  return request({
    url: '/bookPlatform/promotionLinkTemplate/platformList',
    method: 'get',
    params
  })
}
// 获取策略平台(书城活动专用)
export function strategyPlatformthree(params) {
  return request({
    url: '/bookPlatform/activityTemplate/platformList',
    method: 'get',
    params
  })
}
// 获取模板消息列表
export function templatelist(params) {
  return request({
    url: '/templateMessageLib/index',
    method: 'get',
    params
  })
}
// 策略添加
export function addstrategy(data) {
  return request({
    url: '/strategy/create',
    method: 'post',
    data
  })
}
// 策略列表
export function policylist(params) {
  return request({
    url: '/strategy/index',
    method: 'get',
    params
  })
}
// 策略绑定公众号
export function strategybindaccout(data) {
  return request({
    url: '/strategyBind/bindAppIds',
    method: 'post',
    data
  })
}
// 策略解绑公众号
export function unbindaccount(data) {
  return request({
    url: '/strategyBind/removeBindAppIds',
    method: 'post',
    data
  })
}
// 刷新策略
export function undatastartey(params) {
  return request({
    url: '/strategyBind/refreshBindStatus',
    method: 'get',
    params
  })
}
// 获取未绑定的公众号列表
export function unbindaccountlist(params) {
  return request({
    url: '/officialAccount/listForStrategy',
    method: 'get',
    params
  })
}
// 获取未绑定的公众号列表（菜单）
export function unbindmenulist(params) {
  return request({
    url: '/officialAccount/listForMenu',
    method: 'get',
    params
  })
}
// 管理员创建模板消息列表
export function templateadminlist(params) {
  return request({
    url: '/templateAdmin/list',
    method: 'get',
    params
  })
}
// 管理员标签列表
export function adminlist(params) {
  return request({
    url: '/tags/adminGroup/index',
    method: 'get',
    params
  })
}
// 创建定时推送
export function creattimepush(data) {
  return request({
    url: '/timingPush/create',
    method: 'post',
    data
  })
}
// 定时推送列表
export function timingpushlist(params) {
  return request({
    url: '/timingPush/list',
    method: 'get',
    params
  })
}
// 停止推送
export function stoppush(data) {
  return request({
    url: '/timingPush/stopSend',
    method: 'post',
    data
  })
}

// 获取模版列表
export function getTemplateList() {
  return request({
    url: '/templateMessageLib/index',
    method: 'get'
  })
}

// 创建模版消息
export function createTemplateMessage(data = {}) {
  return request({
    url: '/templateAdmin/create',
    method: 'post',
    data
  })
}
// 客服消息预览
export function servicelook(params) {
  return request({
    url: '/customerMessage/preview',
    method: 'get',
    params
  })
}
// 管理员模板消息预览
export function administratorslook(params) {
  return request({
    url: '/templateAdmin/preview',
    method: 'get',
    params
  })
}
// 策略信息
export function strategyinfo(params) {
  return request({
    url: '/strategy/info',
    method: 'get',
    params
  })
}
// 授权
export function wechatauth(params) {
  return request({
    url: '/wechatAuth/getAuthUrl',
    method: 'get',
    params
  })
}
// 异常信息列表
export function adminerrorLog(params) {
  return request({
    url: '/adminBusinessErrorLog/index',
    method: 'get',
    params
  })
}
// 异常信息类型列表
export function adminbusinesserrorLog(params) {
  return request({
    url: '/adminBusinessErrorLog/typeList',
    method: 'get',
    params
  })
}

// 策略列表（单公众号绑定用）
export function listforOfficialbind(params) {
  return request({
    url: '/strategy/listForOfficialBind',
    method: 'get',
    params
  })
}
// 删除策略
export function deleteaccountitem(data) {
  return request({
    url: '/strategyPreview/delStrategy',
    method: 'post',
    data
  })
}
// 客服消息添加
export function customeradd(data) {
  return request({
    url: '/workWechat/kfMsg/store',
    method: 'post',
    data
  })
}
// 客服消息列表
export function workwechatlist(params) {
  return request({
    url: '/workWechat/kfMsg/index',
    method: 'get',
    params
  })
}
// 客服消息更新
export function workWechatupdata(data) {
  return request({
    url: '/workWechat/kfMsg/update',
    method: 'post',
    data
  })
}

// 客服消息删除
export function workWechatdestroy(data) {
  return request({
    url: '/workWechat/kfMsg/destroy',
    method: 'post',
    data
  })
}

// 企业添加
export function anonymousadd(data) {
  return request({
    url: '/feishu/corp/create',
    method: 'post',
    data
  })
}
// 企业列表
export function enterpriselist(params) {
  return request({
    url: '/feishu/corp/index',
    method: 'get',
    params
  })
}

// 应用添加
export function addapplication(data) {
  return request({
    url: '/feishu/app/create',
    method: 'post',
    data
  })
}
// 应用添加
export function applicationlist(params) {
  return request({
    url: '/feishu/app/index',
    method: 'get',
    params
  })
}
// 更新部门
export function updataapplication(data) {
  return request({
    url: '/feishu/corp/updateDepartment',
    method: 'post',
    data
  })
}
// 更新员工
export function updataemployee(data) {
  return request({
    url: '/feishu/corp/updateEmployee',
    method: 'post',
    data
  })
}
// 企业更新
export function enterpriseupdate(data) {
  return request({
    url: '/feishu/corp/update',
    method: 'post',
    data
  })
}
// 获取授权页面
export function feishuAuthAuthPage(params) {
  return request({
    url: '/feishu/auth/authPage',
    method: 'get',
    params
  })
}
// 飞书成员列表
export function feishuChatGetFeiShuUser(params) {
  return request({
    url: '/feishu/chat/getFeiShuUser',
    method: 'get',
    params
  })
}
// 拉取外部群
export function feishuChatPullExternalGroup(data) {
  return request({
    url: '/feishu/chat/pullExternalGroup',
    method: 'post',
    data
  })
}
// 企业筛选
export function enterprisefiltering(params) {
  return request({
    url: '/feishu/corp/list',
    method: 'get',
    params
  })
}
// 应用更新
export function updatefiltering(params) {
  return request({
    url: '/feishu/app/update',
    method: 'post',
    params
  })
}
// 应用删除
export function deltefiltering(data) {
  return request({
    url: '/feishu/app/destroy',
    method: 'post',
    data
  })
}
// 企业删除
export function deltedestroy(data) {
  return request({
    url: '/feishu/corp/destroy',
    method: 'post',
    data
  })
}
// 红包记录
export function redenveloperecord(params) {
  return request({
    url: '/capital/redPacket/list',
    method: 'get',
    params
  })
}
// 群聊列表
export function groupchat(params) {
  return request({
    url: '/feishu/chat/index',
    method: 'get',
    params
  })
}
// 获取群成员列表
export function getquanlist(params) {
  return request({
    url: '/feishu/chat/members',
    method: 'get',
    params
  })
}
// 公众号列表
export function getaccountlist(params) {
  return request({
    url: '/weibo/account/list',
    method: 'get',
    params
  })
}
// 添加biz
export function addbiz(data) {
  return request({
    url: '/weibo/avatarConfig/createLoginData',
    method: 'post',
    data
  })
}
// 更新biz
export function editbiz(data) {
  return request({
    url: '/weibo/avatarConfig/updateLoginData',
    method: 'post',
    data
  })
}
// biz登陆信息列表
export function getbizlist(params) {
  return request({
    url: '/weibo/avatarConfig/loginData',
    method: 'get',
    params
  })
}
// 成员公众号
export function accountconfiglist(params) {
  return request({
    url: '/weibo/avatarConfig/numberInfoData',
    method: 'get',
    params
  })
}
// 创建成员
export function creatpeople(params) {
  return request({
    url: '/weibo/avatarConfig/createNumberInfo',
    method: 'post',
    params
  })
}
// 修改成员
export function editpeople(params) {
  return request({
    url: '/weibo/avatarConfig/updateNumberInfo',
    method: 'post',
    params
  })
}
// 创建图集封面
export function creatcover(params) {
  return request({
    url: '/activity/Atlas/createAtlas',
    method: 'post',
    params
  })
}
// 公众号筛选列表
export function officialaccountlist(params) {
  return request({
    url: '/officialAccount/listForFilter',
    method: 'get',
    params
  })
}
// 图集封面列表
export function atlaslist(params) {
  return request({
    url: '/activity/Atlas/atlasList',
    method: 'get',
    params
  })
}
// 更新图集封面
export function updatacover(params) {
  return request({
    url: '/activity/Atlas/updateAtlas',
    method: 'post',
    params
  })
}
// 删除图集封面
export function deletecover(params) {
  return request({
    url: '/activity/Atlas/atlasDelete',
    method: 'post',
    params
  })
}
// 小说列表
export function novellist(params) {
  return request({
    url: '/novel/index',
    method: 'get',
    params
  })
}
// 图集详情创建
export function activitycover(params) {
  return request({
    url: '/activity/Atlas/createAtlasInfo',
    method: 'post',
    params
  })
}
// 图集详情列表
export function atlasinfolist(params) {
  return request({
    url: '/activity/Atlas/atlasInfoList',
    method: 'get',
    params
  })
}
// 图集详情更新
export function atlasupdata(params) {
  return request({
    url: '/activity/Atlas/updateAtlasInfo',
    method: 'post',
    params
  })
}
// 图集详情删除
export function atlasdelete(params) {
  return request({
    url: '/activity/Atlas/atlasInfoDelete',
    method: 'post',
    params
  })
}
// 赠送图集详情列表
export function atlasdeletesew(params) {
  return request({
    url: '/activity/Atlas/atlasInfoSelect',
    method: 'get',
    params
  })
}
// 后台客服赠送图集
export function customerservice(params) {
  return request({
    url: '/activity/Atlas/giveAtlasInfo',
    method: 'post',
    params
  })
}
// 排行榜列表
export function rankinglist(params) {
  return request({
    url: '/activity/Atlas/rankingRecords',
    method: 'get',
    params
  })
}

// 阅文获取充值活动模板参数
export function readinglist(params) {
  return request({
    url: '/bookPlatform/yueWen/activity/rechargeParam',
    method: 'get',
    params
  })
}
// 阅文创建充值活动模板
export function readingservice(data) {
  return request({
    url: '/bookPlatform/activityTemplate/createActivityTemplate',
    method: 'post',
    data
  })
}
// 阅文充值活动列表
export function readingarlist(params) {
  return request({
    url: '/bookPlatform/activityTemplate/index',
    method: 'get',
    params
  })
}
// 公众号图文模板创建
export function officialaccount(data) {
  return request({
    url: '/officialAccount/articlesStore',
    method: 'post',
    data
  })
}
// 公众号图文模板列表
export function accountlist(params) {
  return request({
    url: '/officialAccount/articlesList',
    method: 'get',
    params
  })
}

// 公众号图文模板编辑
export function editaccount(data) {
  return request({
    url: '/officialAccount/articlesUpdate',
    method: 'post',
    data
  })
}
// 公众号图文模板删除
export function atemplatedeletion(data) {
  return request({
    url: '/officialAccount/articlesDel',
    method: 'post',
    data
  })
}
// 公众号图文模板复用
export function multiplexingtion(data) {
  return request({
    url: '/officialAccount/articlesCopy',
    method: 'post',
    data
  })
}
// 获取各活动配置
export function acawraccountlist(params) {
  return request({
    url: '/bookPlatform/activityTemplate/getActivityMap',
    method: 'get',
    params
  })
}
// 群发列表
export function massdispatchlist(params) {
  return request({
    url: '/timingPushArtc/list',
    method: 'get',
    params
  })
}
// 群发新增
export function gerwinda(data) {
  return request({
    url: '/timingPushArtc/create',
    method: 'post',
    data
  })
}
// 停止推送
export function sttyow(data) {
  return request({
    url: '/timingPushArtc/stopSend',
    method: 'post',
    data
  })
}
// 小程序转盘用户列表
export function turntableuserlist(params) {
  return request({
    url: '/activity/Turntable/turntableUserList',
    method: 'get',
    params
  })
}
// 九宫格小程序用户列表
export function turnineuserlist(params) {
  return request({
    url: '/activity/ninesquares/ninesquaresUserList',
    method: 'get',
    params
  })
}
// 书币兑换
export function exchangebookcurrency(data) {
  return request({
    url: '/activity/Turntable/exchangeBookCurrency',
    method: 'post',
    data
  })
}
// 九宫格书币兑换
export function exchangeninecurrency(data) {
  return request({
    url: '/activity/ninesquares/exchangeBookCurrency',
    method: 'post',
    data
  })
}
// 转盘小程序兑换记录
export function exchangeRecordList(params) {
  return request({
    url: '/activity/Turntable/exchangeRecordList',
    method: 'get',
    params
  })
}
// 九宫格兑换记录
export function exchangenineRecordList(params) {
  return request({
    url: '/activity/ninesquares/exchangeRecordList',
    method: 'get',
    params
  })
}
// 抽奖记录
export function exchangeRecordListr(params) {
  return request({
    url: '/activity/Turntable/prizeRecordList',
    method: 'get',
    params
  })
}
// 九宫格抽奖记录
export function exchangenineRecordListr(params) {
  return request({
    url: '/activity/ninesquares/prizeRecordList',
    method: 'get',
    params
  })
}
// 小程序列表
export function programlist(params) {
  return request({
    url: '/officialAccount/indexMp',
    method: 'get',
    params
  })
}
// 公众号绑定小程序申请
export function publicapplication(data) {
  return request({
    url: '/officialAccount/creatempBind',
    method: 'post',
    data
  })
}
// 公众号绑定小程序列表
export function publicwechatlist(params) {
  return request({
    url: '/officialAccount/bindmpList',
    method: 'get',
    params
  })
}
// 公众号解绑小程序
export function accountunbind(data) {
  return request({
    url: '/officialAccount/mpUnbind',
    method: 'post',
    data
  })
}
// 公众号恢复使用
export function accountrestore(data) {
  return request({
    url: '/officialAccount/mpUnbind',
    method: 'post',
    data
  })
}
// 公众号绑定小程序刷新状态
export function accountrefresh(data) {
  return request({
    url: '/officialAccount/refreshBind',
    method: 'post',
    data
  })
}
// 主动推送公众号文章弹窗推送结果列表
export function sendresults(params) {
  return request({
    url: '/timingPushArtc/sendResults',
    method: 'get',
    params
  })
}
// 主动推送公众号文章的推送结果刷新
export function fetchres(params) {
  return request({
    url: '/pushArtcRes/fetchRes',
    method: 'get',
    params
  })
}
// 刷新公众号列表推送状态
export function updataaccountpushstate(params) {
  return request({
    url: '/timingPushArtc/rebind',
    method: 'get',
    params
  })
}

// 转盘配置创建
export function createturntableconfig(data) {
  return request({
    url: '/activity/Turntable/createTurntableConfig',
    method: 'post',
    data
  })
}
// 九宫格配置创建
export function createninesquaresconfig(data) {
  return request({
    url: '/activity/ninesquares/createTurntableConfig',
    method: 'post',
    data
  })
}
// 转盘配置修改
export function updataturntableconfig(data) {
  return request({
    url: '/activity/Turntable/updateTurntableConfig',
    method: 'post',
    data
  })
}
// 九宫格配置修改
export function updatanineconfig(data) {
  return request({
    url: '/activity/ninesquares/updateTurntableConfig',
    method: 'post',
    data
  })
}
// 转盘配置列表
export function turntablelist(params) {
  return request({
    url: '/activity/Turntable/turntableConfigList',
    method: 'get',
    params
  })
}
// 九宫格配置列表
export function ninesquareslist(params) {
  return request({
    url: '/activity/ninesquares/turntableConfigList',
    method: 'get',
    params
  })
}
// 转盘配置绑定判断
export function turntableconfigbind(params) {
  return request({
    url: '/activity/Turntable/judgeTurntableConfigBind',
    method: 'get',
    params
  })
}
// 九宫格小程序配置绑定判断
export function nineturntableconfigbind(params) {
  return request({
    url: '/activity/ninesquares/judgeConfigBind',
    method: 'get',
    params
  })
}
// 转盘配置绑定创建
export function createturntableconfigbind(data) {
  return request({
    url: '/activity/Turntable/createTurntableConfigBind',
    method: 'post',
    data
  })
}
// 九宫格小程序配置绑定创建
export function createnineconfigbind(data) {
  return request({
    url: '/activity/ninesquares/createConfigBind',
    method: 'post',
    data
  })
}
// 转盘配置绑定列表
export function configurelist(params) {
  return request({
    url: '/activity/Turntable/turntableConfigBindList',
    method: 'get',
    params
  })
}
// 九宫格配置绑定列表
export function nineconfigurelist(params) {
  return request({
    url: '/activity/ninesquares/configBindList',
    method: 'get',
    params
  })
}
// 转盘配置删除
export function delturntableconfig(data) {
  return request({
    url: '/activity/Turntable/delTurntableConfig',
    method: 'post',
    data
  })
}
// 九宫格配置删除
export function deljiugonggeconfig(data) {
  return request({
    url: '/activity/ninesquares/delTurntableConfig',
    method: 'post',
    data
  })
}
// 获取草稿箱
export function getdraftslist(params) {
  return request({
    url: '/mpDrafts/list',
    method: 'get',
    params
  })
}
// 模板库将草稿添加到模板
export function adddraftstemplate(params) {
  return request({
    url: '/mpDrafts/addToTemplate',
    method: 'get',
    params
  })
}
// 模板库获取模板列表
export function templatelibrarylist(params) {
  return request({
    url: '/mpTemplates/list',
    method: 'get',
    params
  })
}
// 第三方模板库删除模板
export function templatedelete(params) {
  return request({
    url: '/mpTemplates/delTemplates',
    method: 'get',
    params
  })
}
// 模板库上传代码并生成体验版
export function goexperience(data) {
  return request({
    url: '/mpCodeTmp/commitTmp',
    method: 'post',
    data
  })
}
// 模板库体验版列表
export function experiencelist(params) {
  return request({
    url: '/mpCodeTmp/list',
    method: 'get',
    params
  })
}
// 模板库体验版列表提交代码审核
export function submitaudit(data) {
  return request({
    url: '/mpCodeTmp/submitAudit',
    method: 'post',
    data
  })
}
// 模板库体验版列表发布已通过审核的小程序
export function sendsubmitaudit(params) {
  return request({
    url: '/mpCodeTmp/releaseMp',
    method: 'get',
    params
  })
}
// 模板库体验版列表不发布已通过审核的小程序
export function nosendsubmitaudit(params) {
  return request({
    url: '/mpCodeTmp/releaseMp',
    method: 'get',
    params
  })
}
// 模板库获取草稿箱列表并同步
export function updataasycdrafts(params) {
  return request({
    url: '/mpDrafts/asycDrafts',
    method: 'get',
    params
  })
}
// 模板库同步模板列表
export function updataayscTemplates(params) {
  return request({
    url: '/mpTemplates/ayscTemplates',
    method: 'get',
    params
  })
}
// 模板库体验版列表刷新审核状态
export function updatarefreshauditSt(params) {
  return request({
    url: '/mpCodeTmp/refreshAuditSt',
    method: 'get',
    params
  })
}
// 模板库体验版二维码获取
export function gettemplater(params) {
  return request({
    url: '/mpCodeTmp/genTestQrcode',
    method: 'get',
    params
  })
}
// 连续签到记录
export function signrecordlist(params) {
  return request({
    url: '/activity/Turntable/signRecordList',
    method: 'get',
    params
  })
}
// 九宫格连续签到记录
export function signininerecordlist(params) {
  return request({
    url: '/activity/ninesquares/signRecordList',
    method: 'get',
    params
  })
}
// 公众号绑定商户号
export function merchantbindoa(data) {
  return request({
    url: '/capital/merchantBindOa/createBind',
    method: 'post',
    data
  })
}
// 红包活动绑定的公众号列表
export function actbindedoaslist(params) {
  return request({
    url: '/activity/redPacket/actBindedOas',
    method: 'get',
    params
  })
}
// 红包活动解绑公众号
export function ubbindoas(params) {
  return request({
    url: '/activity/redPacket/ubBindOas',
    method: 'get',
    params
  })
}
// 上传商户号的证书文件
export function uploadcert(data) {
  return request({
    url: '/capital/merchant/uploadCert',
    method: 'post',
    data
  })
}
// 测试红包发送到公众号用户
export function testredpacketswell(data) {
  return request({
    url: '/activity/redPacket/testRedPacketsWell',
    method: 'post',
    data
  })
}
// 获取模板活动筛选列表
export function activitytemplate(params) {
  return request({
    url: '/bookPlatform/activityTemplate/list',
    method: 'get',
    params
  })
}
// 域名配置列表
export function domainname(params) {
  return request({
    url: '/domainConfigure/domainConfigureList',
    method: 'get',
    params
  })
}
// 域名配置创建
export function domainconfigurelist(data) {
  return request({
    url: '/domainConfigure/domainConfigureCreate',
    method: 'post',
    data
  })
}
// 域名配置修改
export function domainconfigureupdate(data) {
  return request({
    url: '/domainConfigure/domainConfigureUpdate',
    method: 'post',
    data
  })
}
// 域名配置删除
export function domainconfiguredel(data) {
  return request({
    url: '/domainConfigure/domainConfigureDel',
    method: 'post',
    data
  })
}
// 获取小程序类型
export function mptypeslist(params) {
  return request({
    url: '/customerMessage/mpTypes',
    method: 'get',
    params
  })
}
// 获取可添加成员列表
export function canaddmembers(params) {
  return request({
    url: '/feishu/chat/canAddMembers',
    method: 'get',
    params
  })
}
// 群聊拉取成员
export function addmembers(data) {
  return request({
    url: '/feishu/chat/addMembers',
    method: 'post',
    data
  })
}
// 群聊创建
export function groupchatcreate(data) {
  return request({
    url: '/feishu/chat/create',
    method: 'post',
    data
  })
}
// 群聊移除成员
export function removemembers(data) {
  return request({
    url: '/feishu/chat/removeMembers',
    method: 'post',
    data
  })
}
// 主动推送公众号文章预览
export function articlepreview(data) {
  return request({
    url: '/timingPushArtc/articlePreview',
    method: 'post',
    data
  })
}
// 获取历史记录
export function historyWechatNo(params) {
  return request({
    url: '/timingPushArtc/historyWechatNo',
    method: 'get',
    params
  })
}
// 公众号解绑商户号列表发送测试红包
export function testbind(data) {
  return request({
    url: '/capital/merchantBindOa/testBind',
    method: 'post',
    data
  })
}

// 公众号解绑商户号列表刷新绑定状态
export function refreshbind(data) {
  return request({
    url: '/capital/merchantBindOa/refreshBind',
    method: 'post',
    data
  })
}
// 策略详情中定时推送记录
export function pushrecords(params) {
  return request({
    url: '/strategy/pushRecords',
    method: 'get',
    params
  })
}
// 模板消息列表
export function templatemessagelib(params) {
  return request({
    url: '/templateMessageLib/index',
    method: 'get',
    params
  })
}
// 模板消息新增微信行业模板
export function templatemessageliball(data) {
  return request({
    url: '/templateMessageLib/create',
    method: 'post',
    data
  })
}
// 模板消息编辑微信行业模板
export function updatelibr(data) {
  return request({
    url: '/templateMessageLib/updateLib',
    method: 'post',
    data
  })
}
// 公众号接口被封情况列表
export function oatesting(params) {
  return request({
    url: '/risk/oatesting/list',
    method: 'get',
    params
  })
}
// 新增公众号接口被封测试
export function oatestingcreate(data) {
  return request({
    url: '/risk/oatesting/create',
    method: 'post',
    data
  })
}
// 编辑公众号接口被封测试
export function oatestingupdate(data) {
  return request({
    url: '/risk/oatesting/update',
    method: 'post',
    data
  })
}
// 公众号扫码登录列表
export function accountloginlist(params) {
  return request({
    url: '/scanNumberInfo/getList',
    method: 'get',
    params
  })
}
// 公众号扫码登录创建
export function createscannumberinfo(data) {
  return request({
    url: '/scanNumberInfo/create',
    method: 'post',
    data
  })
}
// 公众号扫码登录修改
export function updatascannumberinfo(data) {
  return request({
    url: '/scanNumberInfo/update',
    method: 'post',
    data
  })
}
// 后台小程序列表
export function appletlistrw(params) {
  return request({
    url: '/officialAccount/getList',
    method: 'get',
    params
  })
}
// 编辑时选择的小程序列表
export function getAppletAndBind(params) {
  return request({
    url: '/appletVideo/videoSetting/getAppletAndBind',
    method: 'get',
    params
  })
}
// 运营用户列表
export function operatelist(params) {
  return request({
    url: '/user/getList',
    method: 'get',
    params
  })
}
// 素材类型列表
export function materialroadtype(params) {
  return request({
    url: '/sourceMaterial/btypes',
    method: 'get',
    params
  })
}
// 修改公众号状态
export function updatestatuswe(data) {
  return request({
    url: '/officialAccount/updateStatus',
    method: 'post',
    data
  })
}
// 修改公众号解除禁用
export function accountrelieveupdata(data) {
  return request({
    url: '/officialAccount/liftBan',
    method: 'post',
    data
  })
}
// 修改公众号解除禁用
export function accountclearQuota(data) {
  return request({
    url: '/officialAccount/clearQuota',
    method: 'post',
    data
  })
}
// 获取各书籍H5模板配置
export function createtemplate(params) {
  return request({
    url: '/bookPlatform/promotionLinkTemplate/configMap',
    method: 'get',
    params
  })
}
// 创建H5链接模板
export function bookPlatformcreate(data) {
  return request({
    url: '/bookPlatform/promotionLinkTemplate/createTemplate',
    method: 'post',
    data
  })
}
// 书城推广链接列表
export function promotionlinktemplate(params) {
  return request({
    url: '/bookPlatform/promotionLinkTemplate/getList',
    method: 'get',
    params
  })
}
// 删除推广链接
export function delbookPlatformcreate(data) {
  return request({
    url: '/bookPlatform/promotionLinkTemplate/del',
    method: 'post',
    data
  })
}
// 获取授权类型
export function authorizationtypelist(params) {
  return request({
    url: '/domainConfigure/listTypes',
    method: 'get',
    params
  })
}
// 主动推送公众号文章绑定的公众号列表
export function boundaccountslist(params) {
  return request({
    url: '/timingPushArtc/boundAccounts',
    method: 'get',
    params
  })
}
// 策略绑定的公众号
export function getbinaccount(params) {
  return request({
    url: '/strategyBind/getBindAccount',
    method: 'get',
    params
  })
}
// 红包活动绑定公众号状态刷新
export function refreshbindingbox(params) {
  return request({
    url: '/activity/redPacket/refreshBinding',
    method: 'get',
    params
  })
}
// 飞书错误通知列表
export function erroralarmList(params) {
  return request({
    url: '/feishu/chat/errorAlarmList',
    method: 'get',
    params
  })
}
// 定时推送绑定的公众号列表
export function boundaccounts(params) {
  return request({
    url: '/timingPush/boundAccounts',
    method: 'get',
    params
  })
}
// 通知类型下拉列表
export function geterrortypeList(params) {
  return request({
    url: '/feishu/chat/getErrorTypeList',
    method: 'get',
    params
  })
}
// 通知创建
export function createerroralarm(data) {
  return request({
    url: '/feishu/chat/createErrorAlarm',
    method: 'post',
    data
  })
}
// 通知修改
export function updateerroralarm(data) {
  return request({
    url: '/feishu/chat/updateErrorAlarm',
    method: 'post',
    data
  })
}
// 通知删除
export function delerroralarm(data) {
  return request({
    url: '/feishu/chat/delErrorAlarm',
    method: 'post',
    data
  })
}
// 获取书城推广页面跳转链接
export function promotiondocument(params) {
  return request({
    url: '/bookPlatform/promotionDocument/link',
    method: 'get',
    params
  })
}
// 获取书城页面类型
export function getlinktypeslist(params) {
  return request({
    url: '/bookPlatform/getLinkTypes',
    method: 'get',
    params
  })
}
// 获取章节素材
export function promotionmaterialcontent(params) {
  return request({
    url: '/bookPlatform/promotionMaterial/content',
    method: 'get',
    params
  })
}
// 获取封面素材
export function promotionmaterial(params) {
  return request({
    url: '/bookPlatform/promotionMaterial/cover',
    method: 'get',
    params
  })
}
// 获取标题素材
export function promotionmaterialtitle(params) {
  return request({
    url: '/bookPlatform/promotionMaterial/title',
    method: 'get',
    params
  })
}
// 获取底部引导素材
export function promotionmaterialguide(params) {
  return request({
    url: '/bookPlatform/promotionMaterial/guide',
    method: 'get',
    params
  })
}
// 获取图片筛选项
export function promotionmaterialtypelist(params) {
  return request({
    url: '/bookPlatform/promotionMaterial/typeList',
    method: 'get',
    params
  })
}
// 解散群聊
export function deletechat(data) {
  return request({
    url: '/feishu/chat/deleteChat',
    method: 'post',
    data
  })
}
// 菜单模板绑定公众号记录
export function officialaccountmenulist(params) {
  return request({
    url: '/officialAccountMenu/index',
    method: 'get',
    params
  })
}
// 公众号列表导出
export function officialAccountexport(data) {
  return request({
    url: '/officialAccount/export',
    method: 'post',
    data
  })
}
// 群发模板预览列表
export function timingpushArtcpreviewlist(params) {
  return request({
    url: '/timingPushArtcPreview/list',
    method: 'get',
    params
  })
}
// 群发模板预览停止推送
export function timingstopsend(data) {
  return request({
    url: '/timingPushArtcPreview/stopSend',
    method: 'post',
    data
  })
}
// 群发模板预览删除
export function timingdelete(data) {
  return request({
    url: '/timingPushArtcPreview/delete',
    method: 'post',
    data
  })
}
// 群发模板预览创建
export function timingcreate(data) {
  return request({
    url: '/timingPushArtcPreview/create',
    method: 'post',
    data
  })
}
// 群发模板预览加入常用openid
export function timingoppid(data) {
  return request({
    url: '/timingPushArtcPreview/update',
    method: 'post',
    data
  })
}

// 主副号绑定列表
export function bangaccountlist(params) {
  return request({
    url: '/officialRelation/mainSublist',
    method: 'get',
    params
  })
}
// 主副号绑定
export function mainbindsub(data) {
  return request({
    url: '/officialRelation/mainBindSub',
    method: 'post',
    data
  })
}

//
export function newPicture(data) {
  return request({
    url: '/workWechat/kfMsg/sotre',
    method: 'post',
    data
  })
}

// 主副号解绑绑
export function mainunbindsub(params) {
  return request({
    url: '/officialRelation/mainUnbindSub',
    method: 'get',
    params
  })
}
// 修改公众号粉丝数
export function updatafans(data) {
  return request({
    url: '/officialAccount/updateFansNumber',
    method: 'post',
    data
  })
}
// 即刻刷新关注用户
export function updatausers(data) {
  return request({
    url: '/officialAccount/immediately',
    method: 'post',
    data
  })
}
// 平台列表
export function platformlist(params) {
  return request({
    url: '/bookPlatform/index',
    method: 'get',
    params
  })
}
// 账号创建
export function accountstore(data) {
  return request({
    url: '/bookPlatform/account/store',
    method: 'post',
    data
  })
}
// 账号列表
export function accountindex(params) {
  return request({
    url: '/bookPlatform/account/index',
    method: 'get',
    params
  })
}
// 账号更新
export function accountstoreupdata(data) {
  return request({
    url: '/bookPlatform/account/update',
    method: 'post',
    data
  })
}
// 账号删除
export function accountdestroy(data) {
  return request({
    url: '/bookPlatform/account/destroy',
    method: 'post',
    data
  })
}
// 平台创建
export function bookplatformstore(data) {
  return request({
    url: '/bookPlatform/store',
    method: 'post',
    data
  })
}
export function bookplatformupdate(data) {
  return request({
    url: '/bookPlatform/update',
    method: 'post',
    data
  })
}

// 获取微信号列表
export function getWeChatList(params) {
  return request({
    url: '/scan/vxAccountList',
    method: 'get',
    params
  })
}
// 公众号图文模板详情
export function articleDetail(params) {
  return request({
    url: '/officialAccount/articleDetail',
    method: 'get',
    params
  })
}
// 转盘配置绑定更新
export function updateTurntableConfigBind(data) {
  return request({
    url: '/activity/Turntable/updateTurntableConfigBind',
    method: 'post',
    data
  })
}
// 九宫格配置绑定更新
export function updateninesquaresConfigBind(data) {
  return request({
    url: '/activity/ninesquares/updateConfigBind',
    method: 'post',
    data
  })
}
// 手动扫码
export function manualScandetial(params) {
  return request({
    url: '/scanNumberInfo/manualScan',
    method: 'get',
    params
  })
}
// 客服消息删除
export function customerMessagedelete(params) {
  return request({
    url: '/customerMessage/delete',
    method: 'get',
    params
  })
}
// 客服消息删除
export function templateAdmindelete(params) {
  return request({
    url: '/templateAdmin/delete',
    method: 'get',
    params
  })
}
// 获取可以改绑的管理员列表
export function getadminlist(params) {
  return request({
    url: '/officialAccount/getSubordinateAdminList',
    method: 'get',
    params
  })
}
export function changeAdminupdata(data) {
  return request({
    url: '/officialAccount/changeAdmin',
    method: 'post',
    data
  })
}
// 群发模板导入微信文章（图片）
export function importoffcount(data) {
  return request({
    url: '/officialAccount/importWxArticle',
    method: 'post',
    data
  })
}
// 九宫格小程序用户团队信息
export function getTeammateslist(params) {
  return request({
    url: '/activity/ninesquares/getTeammates',
    method: 'get',
    params
  })
}
// ota升级列表
export function otalist(params) {
  return request({
    url: '/scan/getOtaList',
    method: 'get',
    params
  })
}
// ota升级创建
export function createOta(data) {
  return request({
    url: '/scan/createOta',
    method: 'post',
    data
  })
}
// ota升级修改
export function updataOta(data) {
  return request({
    url: '/scan/updateOta',
    method: 'post',
    data
  })
}
// ota功能配置列表
export function getOtaConfigList(params) {
  return request({
    url: '/scan/getOtaConfigList',
    method: 'get',
    params
  })
}
// ota功能配置添加
export function createOtaConfig(data) {
  return request({
    url: '/scan/createOtaConfig',
    method: 'post',
    data
  })
}
// ota升级下发
export function issuedota(data) {
  return request({
    url: '/scan/upgradeSend',
    method: 'post',
    data
  })
}
// ota升级删除
export function delOta(data) {
  return request({
    url: '/scan/delOta',
    method: 'post',
    data
  })
}
// 飞书登录获取二维码参数
export function getFeiShuLoginappInfo(params) {
  return request({
    url: '/feishu/getFeiShuLoginAppInfo',
    method: 'get',
    params
  })
}
// 导出关联公众号
export function exportexcleall(params) {
  return request({
    url: '/officialAccount/bindmpExport',
    method: 'get',
    params
  })
}
// 群发模板底部二维码
export function getBottomImageTemplate(params) {
  return request({
    url: '/officialAccount/getBottomImageTemplate',
    method: 'get',
    params
  })
}

// 定时推送选择的公众号列表
export function listForTimingPush(params) {
  return request({
    url: '/officialAccount/listForTimingPush',
    method: 'get',
    params
  })
}

// 群发文章选择的公众号列表
export function listForTimingArticles(params) {
  return request({
    url: '/officialAccount/listForTimingArticles',
    method: 'get',
    params
  })
}
// 小说刷新
export function platformlistaewr(data) {
  return request({
    url: '/novel/pull',
    method: 'post',
    data
  })
}

// 公众号标签列表
export function listForLabelOfofficialaccount(params) {
  return request({
    url: '/officialAccountTags/index',
    method: 'get',
    params
  })
}

// 公众号用户标签用标签组列表
export function listForOfficialTags(params) {
  return request({
    url: '/tags/adminGroup/listForOfficialTags',
    method: 'get',
    params
  })
}

// 公众号上传标签用公众号列表
export function listForOfficialAccount(params) {
  return request({
    url: '/officialAccount/listForOfficialTag',
    method: 'get',
    params
  })
}

export function officialAccountTags(data) {
  return request({
    url: '/officialAccountTags/create',
    method: 'post',
    data
  })
}

// 批量解绑绑定了小程序的公众号
export function officialAccountunbindByMpAppid(data) {
  return request({
    url: '/officialAccount/unbindByMpAppid',
    method: 'post',
    data
  })
}
// 刷新菜单
export function officialAccountMenurefreshMenus(data) {
  return request({
    url: '/officialAccountMenu/refreshMenus',
    method: 'post',
    data
  })
}

// 小程序优先级设置列表
export function officialAccountlistMpRank(params) {
  return request({
    url: '/officialAccount/listMpRank',
    method: 'get',
    params
  })
}
// 小程序优先级保存
export function officialAccountmpRankStore(data) {
  return request({
    url: '/officialAccount/mpRankStore',
    method: 'post',
    data
  })
}
// 小程序优先级修改
export function officialAccountmpRankModify(data) {
  return request({
    url: '/officialAccount/mpRankModify',
    method: 'post',
    data
  })
}
// 修改小程序类型
export function officialupdateMpType(data) {
  return request({
    url: '/officialAccount/updateMpType',
    method: 'post',
    data
  })
}
// 小程序添加运营组
export function addOpGroup(data) {
  return request({
    url: '/officialAccount/addOpGroup',
    method: 'post',
    data
  })
}
// 主动推送公众号文章的阅读数
export function readStslist(params) {
  return request({
    url: '/pushArtcRes/readSts',
    method: 'get',
    params
  })
}
// 停止单个公众号推送
export function stopOfficialSend(data) {
  return request({
    url: '/timingPush/stopOfficialSend',
    method: 'post',
    data
  })
}

// 员工列表可选参数
export function corpUsersList(params) {
  return request({
    url: '/customerMessage/corpUsersList',
    method: 'get',
    params
  })
}

// 推送客户消息
export function customerMessagepush(data) {
  return request({
    url: '/customerMessage/push',
    method: 'post',
    data
  })
}

// 策略编辑
export function strategyEdit(data) {
  return request({
    url: '/strategy/update',
    method: 'post',
    data
  })
}
// 编辑消息模板
export function customerMessageupdate(data) {
  return request({
    url: '/customerMessage/update',
    method: 'post',
    data
  })
}
// 群发推送查看发送结果删除历史文章
export function timingPushArtcdelete(data) {
  return request({
    url: '/timingPushArtc/delete',
    method: 'post',
    data
  })
}
// 底图/图标配置入库
export function storeSet(data) {
  return request({
    url: '/appletFindDifferent/iconsSet/storeSet',
    method: 'post',
    data
  })
}
// 配置列表
export function iconsSetlist(params) {
  return request({
    url: '/appletFindDifferent/iconsSet/list',
    method: 'get',
    params
  })
}
// 图库列表
export function underlaylist(params) {
  return request({
    url: '/appletFindDifferent/underlay/list',
    method: 'get',
    params
  })
}
// 图片上传入库
export function underlaystoreImage(data = {}) {
  return request({
    url: '/appletFindDifferent/underlay/storeImage',
    method: 'post',
    data
  })
}
// 底图图标详情
export function iconsSetdetails(params) {
  return request({
    url: '/appletFindDifferent/iconsSet/details',
    method: 'get',
    params
  })
}
// 配置编辑
export function iconsSetupdate(data = {}) {
  return request({
    url: '/appletFindDifferent/iconsSet/update',
    method: 'post',
    data
  })
}

// 配置删除
export function underlaydelete(data = {}) {
  return request({
    url: '/appletFindDifferent/iconsSet/delete',
    method: 'post',
    data
  })
}
// 分类配置-列表
export function assortlist(params) {
  return request({
    url: '/appletFindDifferent/assort/list',
    method: 'get',
    params
  })
}
// 分类配置-增
export function assortstore(data = {}) {
  return request({
    url: '/appletFindDifferent/assort/store',
    method: 'post',
    data
  })
}
// 分类配置-更新
export function assortupdate(data = {}) {
  return request({
    url: '/appletFindDifferent/assort/update',
    method: 'post',
    data
  })
}
// 视频配置列表
export function videoSettingList(params) {
  return request({
    url: '/appletVideo/videoSetting/list',
    method: 'get',
    params
  })
}
// 创建视频配置
export function videoSettingAdd(data = {}) {
  return request({
    url: '/appletVideo/videoSetting/store',
    method: 'post',
    data
  })
}
// 更新视频配置
export function videoSettingUpdate(data = {}) {
  return request({
    url: '/appletVideo/videoSetting/update',
    method: 'post',
    data
  })
}
// 视频配置删除
export function videoSettingDelete(data = {}) {
  return request({
    url: '/appletVideo/videoSetting/delete',
    method: 'post',
    data
  })
}
// 视频配置列表
export function videoSettingDetail(params) {
  return request({
    url: '/appletVideo/videoSetting/details',
    method: 'get',
    params
  })
}
// 解绑视频小程序
export function videoUnBindApplet(data = {}) {
  return request({
    url: '/appletVideo/videoSetting/videoUnBindApplet',
    method: 'post',
    data
  })
}
// 绑定小程序记录
export function videoBindAppletRecord(params) {
  return request({
    url: '/appletVideo/videoSetting/videoBindAppletRecord',
    method: 'get',
    params
  })
}
// 小程序视频广告配置列表
export function videoAdSettingList(params) {
  return request({
    url: '/appletVideo/videoAdSetting/list',
    method: 'get',
    params
  })
}
// 小程序列表包括已配置的
export function videoAdSettingBind(params) {
  return request({
    url: '/appletVideo/videoAdSetting/getAppletAndBind',
    method: 'get',
    params
  })
}
// 创建小程序视频广告配置
export function videoAdSettinAdd(data = {}) {
  return request({
    url: '/appletVideo/videoAdSetting/store',
    method: 'post',
    data
  })
}
// 更新小程序视频广告配置
export function videoAdSettingUpdate(data = {}) {
  return request({
    url: '/appletVideo/videoAdSetting/update',
    method: 'post',
    data
  })
}
// 删除小程序视频广告配置
export function videoAdSettingdlt(data = {}) {
  return request({
    url: '/appletVideo/videoAdSetting/delete',
    method: 'post',
    data
  })
}
// 第三方接口搜索视频
export function thirdVideoSearch(params) {
  return request({
    url: '/appletVideo/videoSetting/thirdVideoSearch',
    method: 'get',
    params
  })
}
// 视频列表包括已绑定
export function videoListAndBind(params) {
  return request({
    url: '/appletVideo/videoSetting/videoListAndBind',
    method: 'get',
    params
  })
}
// 视频解绑定小程序
export function videoBindApplet(data = {}) {
  return request({
    url: '/appletVideo/videoSetting/videoBindApplet',
    method: 'post',
    data
  })
}
// cookie列表
export function operateCookie(params) {
  return request({
    url: '/appletVideo/operateCookie/list',
    method: 'get',
    params
  })
}
// cookie删除
export function operateCookiedelete(data = {}) {
  return request({
    url: '/appletVideo/operateCookie/delete',
    method: 'post',
    data
  })
}
// cookie新增
export function operateCookiestore(data = {}) {
  return request({
    url: '/appletVideo/operateCookie/store',
    method: 'post',
    data
  })
}
// 获取可以绑定的公众号列表（预览模式群发）
export function unbindPreviewList(params) {
  return request({
    url: '/strategyPreview/listForOfficialBind',
    method: 'get',
    params
  })
}
// 策略绑定公众号（预览模式群发）
export function strategyPreviewBind(params) {
  return request({
    url: '/strategyPreviewBind/bindAppIds',
    method: 'post',
    params
  })
}
// 获取已经绑定的公众号列表
export function getBindAccount(params) {
  return request({
    url: '/strategyPreviewBind/getBindAccount',
    method: 'get',
    params
  })
}
// 预览群发策略解绑公众号
export function removeBindAppIds(data) {
  return request({
    url: '/strategyPreviewBind/removeBindAppIds',
    method: 'post',
    data
  })
}
// 获取预览群发详情
export function strategyPreviewInfo(params) {
  return request({
    url: '/strategyPreview/info',
    method: 'get',
    params
  })
}
// 修改预览群发
export function updateStrategyPreview(data) {
  return request({
    url: '/strategyPreview/update',
    method: 'post',
    data
  })
}
// 刷新预览群发策略绑定
export function strategyPreviewBindRefresh(params) {
  return request({
    url: '/strategyPreviewBind/refreshBindStatus',
    method: 'get',
    params
  })
}
// 删除预览群发
export function strategyPreviewDelStrategy(params) {
  return request({
    url: '/strategyPreview/delStrategy',
    method: 'post',
    params
  })
}
// 预览群发 发送记录
export function strategyPreviewSendHistory(params) {
  return request({
    url: '/strategyPreview/pushRecords',
    method: 'get',
    params
  })
}
// 预览群发 绑定记录 推送状态
export function stopStrategyPreview(data = {}) {
  return request({
    url: '/strategyPreviewBind/stopStrategyPreview',
    method: 'post',
    data
  })
}
// 小程序运营状态修改
export function officialAccountupdOperationStatus(data = {}) {
  return request({
    url: '/officialAccount/updOperationStatus',
    method: 'post',
    data
  })
}
// 修改公众号备注
export function officialAccountupdateRemark(data = {}) {
  return request({
    url: '/officialAccount/updateRemark',
    method: 'post',
    data
  })
}
// 修改公众号绑定的书城小程序appid
export function officialAccountupdateBookMiniProgramAppld(data = {}) {
  return request({
    url: '/officialAccount/updateBookMiniProgramAppId',
    method: 'post',
    data
  })
}
// 绑定短剧
export function videoSettingrelatedVideo(data = {}) {
  return request({
    url: '/appletLifeVideo/videoSetting/relatedVideo',
    method: 'post',
    data
  })
}
// 域名配置停止
export function domainConfigureStop(data) {
  return request({
    url: '/domainConfigure/domainConfigureStop',
    method: 'post',
    data
  })
}
// 撤回小程序
export function chehuing(data) {
  return request({
    url: '/mpCodeTmp/undoCodeAudit',
    method: 'post',
    data
  })
}
// 获取小程序历史版本
export function getHistoryVersion(data) {
  return request({
    url: '/mpCodeTmp/getHistoryVersion',
    method: 'post',
    data
  })
}
// 回退小程序版本
export function revertCodeRelease(data) {
  return request({
    url: '/mpCodeTmp/revertCodeRelease',
    method: 'post',
    data
  })
}
